var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixEventsV3TicketDefinition from '@wix/ambassador-events-v3-ticket-definition/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var PricingTypeEnumType;
(function (PricingTypeEnumType) {
    PricingTypeEnumType["UNKNOWN_PRICING_TYPE"] = "UNKNOWN_PRICING_TYPE";
    PricingTypeEnumType["STANDARD"] = "STANDARD";
    PricingTypeEnumType["DONATION"] = "DONATION";
})(PricingTypeEnumType || (PricingTypeEnumType = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_FEE_TYPE"] = "UNKNOWN_FEE_TYPE";
    /** Seller absorbs the fee. It is deducted from the ticket price. */
    Type["FEE_INCLUDED"] = "FEE_INCLUDED";
    /** Fee is added to the ticket price at checkout. */
    Type["FEE_ADDED_AT_CHECKOUT"] = "FEE_ADDED_AT_CHECKOUT";
    /** Service fee is not collected - available only for free tickets and legacy users. */
    Type["NO_FEE"] = "NO_FEE";
})(Type || (Type = {}));
export var SaleStatusEnumStatus;
(function (SaleStatusEnumStatus) {
    SaleStatusEnumStatus["UNKNOWN_SALE_STATUS"] = "UNKNOWN_SALE_STATUS";
    /** Ticket sale is scheduled to start */
    SaleStatusEnumStatus["SALE_SCHEDULED"] = "SALE_SCHEDULED";
    /** Ticket sale has started */
    SaleStatusEnumStatus["SALE_STARTED"] = "SALE_STARTED";
    /** Ticket sale has ended */
    SaleStatusEnumStatus["SALE_ENDED"] = "SALE_ENDED";
})(SaleStatusEnumStatus || (SaleStatusEnumStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var ReservationStatus;
(function (ReservationStatus) {
    /**
     * Reservation is pending confirmation.
     * The reservation will expire after the expiration due time.
     */
    ReservationStatus["RESERVATION_PENDING"] = "RESERVATION_PENDING";
    /** The reservation was confirmed and will not expire. */
    ReservationStatus["RESERVATION_CONFIRMED"] = "RESERVATION_CONFIRMED";
    /** The reservation was canceled because of non payment. */
    ReservationStatus["RESERVATION_CANCELED"] = "RESERVATION_CANCELED";
    /** The reservation was canceled manually by the buyer. */
    ReservationStatus["RESERVATION_CANCELED_MANUALLY"] = "RESERVATION_CANCELED_MANUALLY";
    /** The reservation has expired. */
    ReservationStatus["RESERVATION_EXPIRED"] = "RESERVATION_EXPIRED";
})(ReservationStatus || (ReservationStatus = {}));
export var Field;
(function (Field) {
    Field["UNKNOWN_REQUESTED_FIELD"] = "UNKNOWN_REQUESTED_FIELD";
    /** Include `unsoldCount`, `soldCount`, `reservedCount` and `soldOut` in the response. */
    Field["SALES_DETAILS"] = "SALES_DETAILS";
})(Field || (Field = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var LocationType;
(function (LocationType) {
    LocationType["VENUE"] = "VENUE";
    LocationType["ONLINE"] = "ONLINE";
})(LocationType || (LocationType = {}));
export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var Status;
(function (Status) {
    /** Event occurs only once. */
    Status["ONE_TIME"] = "ONE_TIME";
    /** Event is recurring. */
    Status["RECURRING"] = "RECURRING";
    /** Marks the next upcoming occurrence of the recurring event. */
    Status["RECURRING_NEXT"] = "RECURRING_NEXT";
    /** Marks the most recent ended occurrence of the recurring event. */
    Status["RECURRING_LAST_ENDED"] = "RECURRING_LAST_ENDED";
    /** Marks the most recent canceled occurrence of the recurring event. */
    Status["RECURRING_LAST_CANCELED"] = "RECURRING_LAST_CANCELED";
})(Status || (Status = {}));
export var EventStatus;
(function (EventStatus) {
    /** Event is public and scheduled to start */
    EventStatus["SCHEDULED"] = "SCHEDULED";
    /** Event has started */
    EventStatus["STARTED"] = "STARTED";
    /** Event has ended */
    EventStatus["ENDED"] = "ENDED";
    /** Event was canceled */
    EventStatus["CANCELED"] = "CANCELED";
    /** Event is not public and needs to be published */
    EventStatus["DRAFT"] = "DRAFT";
})(EventStatus || (EventStatus = {}));
export var EventType;
(function (EventType) {
    /** Type not available for this request fieldset */
    EventType["NA_EVENT_TYPE"] = "NA_EVENT_TYPE";
    /** Registration via RSVP */
    EventType["RSVP"] = "RSVP";
    /** Registration via ticket purchase */
    EventType["TICKETS"] = "TICKETS";
    /** External registration */
    EventType["EXTERNAL"] = "EXTERNAL";
    /** Registration not available */
    EventType["NO_REGISTRATION"] = "NO_REGISTRATION";
})(EventType || (EventType = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    /** Registration status is not applicable */
    RegistrationStatus["NA_REGISTRATION_STATUS"] = "NA_REGISTRATION_STATUS";
    /** Registration to event is closed */
    RegistrationStatus["CLOSED"] = "CLOSED";
    /** Registration to event is closed manually */
    RegistrationStatus["CLOSED_MANUALLY"] = "CLOSED_MANUALLY";
    /** Registration is open via RSVP */
    RegistrationStatus["OPEN_RSVP"] = "OPEN_RSVP";
    /** Registration to event waitlist is open via RSVP */
    RegistrationStatus["OPEN_RSVP_WAITLIST"] = "OPEN_RSVP_WAITLIST";
    /** Registration is open via ticket purchase */
    RegistrationStatus["OPEN_TICKETS"] = "OPEN_TICKETS";
    /** Registration is open via external URL */
    RegistrationStatus["OPEN_EXTERNAL"] = "OPEN_EXTERNAL";
    /** Registration will be open via RSVP */
    RegistrationStatus["SCHEDULED_RSVP"] = "SCHEDULED_RSVP";
})(RegistrationStatus || (RegistrationStatus = {}));
export var RsvpStatusOptions;
(function (RsvpStatusOptions) {
    /** Only YES RSVP status is available for RSVP registration */
    RsvpStatusOptions["YES_ONLY"] = "YES_ONLY";
    /** YES and NO RSVP status options are available for the registration */
    RsvpStatusOptions["YES_AND_NO"] = "YES_AND_NO";
})(RsvpStatusOptions || (RsvpStatusOptions = {}));
export var TaxType;
(function (TaxType) {
    /** Tax is included in the ticket price */
    TaxType["INCLUDED"] = "INCLUDED";
    /** Tax is added to the order at the checkout */
    TaxType["ADDED"] = "ADDED";
    /** Tax is added to the final total at the checkout */
    TaxType["ADDED_AT_CHECKOUT"] = "ADDED_AT_CHECKOUT";
})(TaxType || (TaxType = {}));
export var VisitorType;
(function (VisitorType) {
    /** Site visitor (including member) */
    VisitorType["VISITOR"] = "VISITOR";
    /** Site member */
    VisitorType["MEMBER"] = "MEMBER";
    /** Site visitor or member */
    VisitorType["VISITOR_OR_MEMBER"] = "VISITOR_OR_MEMBER";
})(VisitorType || (VisitorType = {}));
export var InputControlType;
(function (InputControlType) {
    /** Single text value field. */
    InputControlType["INPUT"] = "INPUT";
    /** Single text value field. */
    InputControlType["TEXTAREA"] = "TEXTAREA";
    /** Single-choice field of predefined values. */
    InputControlType["DROPDOWN"] = "DROPDOWN";
    /** Single-choice field of predefined values. */
    InputControlType["RADIO"] = "RADIO";
    /** Multiple-choice field of predefined values. */
    InputControlType["CHECKBOX"] = "CHECKBOX";
    /** First and last name fields. */
    InputControlType["NAME"] = "NAME";
    /** Additional guests and respective guest names fields. */
    InputControlType["GUEST_CONTROL"] = "GUEST_CONTROL";
    /** Single-line address field. */
    InputControlType["ADDRESS_SHORT"] = "ADDRESS_SHORT";
    /** Full address field. */
    InputControlType["ADDRESS_FULL"] = "ADDRESS_FULL";
    /** Year, month and day fields. */
    InputControlType["DATE"] = "DATE";
})(InputControlType || (InputControlType = {}));
export var ValueType;
(function (ValueType) {
    ValueType["TEXT"] = "TEXT";
    ValueType["NUMBER"] = "NUMBER";
    ValueType["TEXT_ARRAY"] = "TEXT_ARRAY";
    ValueType["DATE_TIME"] = "DATE_TIME";
    ValueType["ADDRESS"] = "ADDRESS";
})(ValueType || (ValueType = {}));
export var ConferenceType;
(function (ConferenceType) {
    /** Everyone in the meeting can publish and subscribe video and audio. */
    ConferenceType["MEETING"] = "MEETING";
    /** Guests can only subscribe to video and audio. */
    ConferenceType["WEBINAR"] = "WEBINAR";
})(ConferenceType || (ConferenceType = {}));
export var CategoryStateState;
(function (CategoryStateState) {
    /** Created manually by the user. */
    CategoryStateState["MANUAL"] = "MANUAL";
    /** Created automatically. */
    CategoryStateState["AUTO"] = "AUTO";
    /** Created when publishing recurring events. */
    CategoryStateState["RECURRING_EVENT"] = "RECURRING_EVENT";
    /** Category is hidden. */
    CategoryStateState["HIDDEN"] = "HIDDEN";
    /** Category is used to store component events. */
    CategoryStateState["COMPONENT"] = "COMPONENT";
})(CategoryStateState || (CategoryStateState = {}));
export var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["PENDING"] = "PENDING";
    State["DEMO"] = "DEMO";
})(State || (State = {}));
export var SiteCreatedContext;
(function (SiteCreatedContext) {
    /** A valid option, we don't expose all reasons why site might be created. */
    SiteCreatedContext["OTHER"] = "OTHER";
    /** A meta site was created from template. */
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    /** A meta site was created by copying of the transfferred meta site. */
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    /** A copy of existing meta site. */
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    /** A meta site was created as a transfferred site (copy of the original), old flow, should die soon. */
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    /** deprecated A meta site was created for Flash editor. */
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext || (SiteCreatedContext = {}));
export var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    /** Default namespace for UGC sites. MetaSites with this namespace will be shown in a user's site list by default. */
    Namespace["WIX"] = "WIX";
    /** ShoutOut stand alone product. These are siteless (no actual Wix site, no HtmlWeb). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    /** MetaSites created by the Albums product, they appear as part of the Albums app. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ALBUMS"] = "ALBUMS";
    /** Part of the WixStores migration flow, a user tries to migrate and gets this site to view and if the user likes it then stores removes this namespace and deletes the old site with the old stores. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    /** Hotels standalone (siteless). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["HOTELS"] = "HOTELS";
    /** Clubs siteless MetaSites, a club without a wix website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["CLUBS"] = "CLUBS";
    /** A partially created ADI website. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    /** AppBuilder for AppStudio / shmite (c). MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_SITE"] = "DEV_SITE";
    /** LogoMaker websites offered to the user after logo purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["LOGOS"] = "LOGOS";
    /** VideoMaker websites offered to the user after video purchase. MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    /** MetaSites with this namespace will *not* be shown in a user's site list by default. */
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    /**
     * A draft created by HTML editor on open. Upon "first save" it will be moved to be of WIX domain.
     *
     * Meta site with this namespace will *not* be shown in a user's site list by default.
     */
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    /**
     * the user-journey for Fitness users who want to start from managing their business instead of designing their website.
     * Will be accessible from Site List and will not have a website app.
     * Once the user attaches a site, the site will become a regular wixsite.
     */
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    /** Belongs to "strategic products" company. Supports new product in the creator's economy space. */
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    /** It is to be used in the Business First efforts. */
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    /** Bookings business flow with no site. */
    Namespace["ANYWHERE"] = "ANYWHERE";
    /** Namespace for Headless Backoffice with no editor */
    Namespace["HEADLESS"] = "HEADLESS";
    /**
     * Namespace for master site that will exist in parent account that will be referenced by subaccounts
     * The site will be used for account level CSM feature for enterprise
     */
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
    /** Rise.ai Siteless account management for Gift Cards and Store Credit. */
    Namespace["RISE"] = "RISE";
    /**
     * As part of the branded app new funnel, users now can create a meta site that will be branded app first.
     * There's a blank site behind the scene but it's blank).
     * The Mobile company will be the owner of this namespace.
     */
    Namespace["BRANDED_FIRST"] = "BRANDED_FIRST";
    /** Nownia.com Siteless account management for Ai Scheduling Assistant. */
    Namespace["NOWNIA"] = "NOWNIA";
})(Namespace || (Namespace = {}));
export var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
})(DeleteStatus || (DeleteStatus = {}));
const _bulkDeleteTicketDefinitionsByFilterRequest = {};
const _bulkDeleteTicketDefinitionsByFilterResponse = {};
const _changeCurrencyRequest = {};
const _changeCurrencyResponse = {};
const _countAvailableTicketDefinitionsRequest = {};
const _countAvailableTicketDefinitionsResponse = {};
const _countTicketDefinitionsRequest = {};
const _countTicketDefinitionsResponse = {};
const _createTicketDefinitionRequest = {};
const _createTicketDefinitionResponse = {};
const _deleteTicketDefinitionRequest = {};
const _deleteTicketDefinitionResponse = {};
const _getTicketDefinitionRequest = {};
const _getTicketDefinitionResponse = {};
const _queryAvailableTicketDefinitionsRequest = {};
const _queryAvailableTicketDefinitionsResponse = {};
const _queryTicketDefinitionsRequest = {};
const _queryTicketDefinitionsResponse = {};
const _reorderTicketDefinitionsRequest = {};
const _reorderTicketDefinitionsResponse = {};
const _updateTicketDefinitionRequest = {};
const _updateTicketDefinitionResponse = {};
/**
 * > **Note:** This function replaces the deprecated `createTicketDefinition()` function. The deprecated function will continue to work until November 8, 2024, but it will not receive updates. To keep any existing code compatible with future changes, see the [migration instructions](https://www.wix.com/velo/reference/wix-events-v2/ticketdefinitions/createticketdefinition).
 *
 *
 * Creates a ticket definition.
 *
 *
 * It is allowed to create up to 100 definitions per event.
 * @param ticketDefinition - Ticket definition info.
 * @public
 * @requiredField ticketDefinition
 * @requiredField ticketDefinition.eventId
 * @requiredField ticketDefinition.feeType
 * @requiredField ticketDefinition.name
 * @requiredField ticketDefinition.pricingMethod
 * @param options - Optional fields.
 * @adminMethod
 * @returns Created ticket definition.
 */
export function createTicketDefinition(ticketDefinition, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            ticketDefinition: '$[0]',
            fields: '$[1].fields',
        };
        const responseTransformation = '$.ticketDefinition';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createTicketDefinitionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['ticketDefinition']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createTicketDefinitionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['ticketDefinition']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([ticketDefinition, options]);
        const reqOpts = ambassadorWixEventsV3TicketDefinition.createTicketDefinition(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'ticketDefinition',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * > **Note:** This function replaces the deprecated `updateTicketDefinition()` function. The deprecated function will continue to work until November 8, 2024, but it will not receive updates. To keep any existing code compatible with future changes, see the [migration instructions](https://www.wix.com/velo/reference/wix-events-v2/ticketdefinitions/updateticketdefinition).
 *
 * Updates a ticket definition.
 *
 *
 * Each time the ticket definition is updated, `revision` increments by 1. The existing `revision` must be included when updating the ticket definition. This ensures you're working with the latest ticket definition and prevents unintended overwrites.
 * @param _id - Ticket definition ID.
 * @public
 * @requiredField _id
 * @requiredField ticketDefinition
 * @requiredField ticketDefinition.revision
 * @param options - Optional fields.
 * @param ticketDefinition - Ticket definition to update.
 * @adminMethod
 * @returns The updated ticket definition.
 */
export function updateTicketDefinition(_id, ticketDefinition, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            ticketDefinition: { '*': '$[1]', id: '$[0]' },
            mask: '$[2].mask',
            fields: '$[2].fields',
        };
        const responseTransformation = '$.ticketDefinition';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateTicketDefinitionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['ticketDefinition']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateTicketDefinitionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['ticketDefinition']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, ticketDefinition, options]);
        const reqOpts = ambassadorWixEventsV3TicketDefinition.updateTicketDefinition(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'ticketDefinition',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * > **Note:** This function replaces the deprecated `getTicketDefinition()` function. The deprecated function will continue to work until November 8, 2024, but it will not receive updates. To keep any existing code compatible with future changes, see the [migration instructions](https://www.wix.com/velo/reference/wix-events-v2/ticketdefinitions/getticketdefinition).
 *
 * Retrieves a ticket definition by ID.
 * @param ticketDefinitionId - Ticket definition ID.
 * @public
 * @requiredField ticketDefinitionId
 * @param options - Optional fields.
 * @adminMethod
 * @returns The requested ticket definition.
 */
export function getTicketDefinition(ticketDefinitionId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            ticketDefinitionId: '$[0]',
            fields: '$[1].fields',
        };
        const responseTransformation = '$.ticketDefinition';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getTicketDefinitionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getTicketDefinitionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['ticketDefinition']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([ticketDefinitionId, options]);
        const reqOpts = ambassadorWixEventsV3TicketDefinition.getTicketDefinition(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'ticketDefinitionId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * > **Note:** This function replaces the deprecated `deleteTicketDefinition()` function. The deprecated function will continue to work until November 8, 2024, but it will not receive updates. To keep any existing code compatible with future changes, see the [migration instructions](https://www.wix.com/velo/reference/wix-events-v2/ticketdefinitions/deleteticketdefinition).
 *
 * Permanently deletes a ticket definition.
 * @param ticketDefinitionId - ID of the ticket definition to delete.
 * @public
 * @requiredField ticketDefinitionId
 * @adminMethod
 */
export function deleteTicketDefinition(ticketDefinitionId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { ticketDefinitionId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteTicketDefinitionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteTicketDefinitionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([ticketDefinitionId]);
        const reqOpts = ambassadorWixEventsV3TicketDefinition.deleteTicketDefinition(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'ticketDefinitionId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Changes ticket definitions order in an event dashboard and the list of available tickets in the ticket picker.
 * > **Note:** It is possible to use both `beforeTicketDefinitionId` and `afterTicketDefinitionId` at the same time but only the last one defined will be executed.
 * @param eventId - Event ID.
 * @public
 * @requiredField eventId
 * @requiredField options.ticketDefinitionId
 * @param options - Optional fields.
 * @adminMethod
 */
export function reorderTicketDefinitions(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            eventId: '$[0]',
            ticketDefinitionId: '$[1].ticketDefinitionId',
            beforeDefinitionId: '$[1].beforeDefinitionId',
            afterDefinitionId: '$[1].afterDefinitionId',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _reorderTicketDefinitionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _reorderTicketDefinitionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV3TicketDefinition.reorderTicketDefinitions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * > **Note:** This function replaces the deprecated `listTicketDefinition()` and `queryTicketDefinitions` functions. The deprecated functions will continue to work until November 8, 2024, but it will not receive updates. To keep any existing code compatible with future changes, see the [migration instructions](https://www.wix.com/velo/reference/wix-events-v2/ticketdefinitions/queryticketdefinitions).
 *
 * Retrieves a list of ticket definitions, given the provided paging, filtering, and sorting.
 * Query Ticket Definitions runs with these defaults, which you can override:
 * - `createdDate` is sorted in `ASC` order
 * - `paging.limit` is `100`
 * - `paging.offset` is `0`
 * @public
 * @param options - Optional fields.
 * @permissionId WIX_EVENTS.READ_TICKET_DEFINITIONS
 * @adminMethod
 */
export function queryTicketDefinitions(options) {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.ticketDefinitions',
        pagingMetadata: '$.metadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[1];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryTicketDefinitionsRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryTicketDefinitionsResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#ticketDefinitions']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixEventsV3TicketDefinition.queryTicketDefinitions(Object.assign(Object.assign({}, payload), (options !== null && options !== void 0 ? options : {})));
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Retrieves a list of available ticket definitions, given the provided paging, filtering, and sorting. <br>
 * This endpoint retrieves ticket definitions that aren't in the `hidden` state. They can be retrieved by site visitors, but to get the `salesDetails` field, the `WIX_EVENTS.READ_TICKET_DEFINITIONS` permission is required. <br>
 * Query Available Ticket Definitions runs with these defaults, which you can override:
 * - `createdDate` is sorted in `ASC` order
 * - `paging.limit` is `100`
 * - `paging.offset` is `0`
 * <br>
 * For field support for filters and sorting, see [Ticket Definitions: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/events/ticket-definition-v3/filter-and-sort).
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * @param query - Query options. See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) for more details.
 * @public
 * @requiredField query
 * @param options - Optional fields.
 */
export function queryAvailableTicketDefinitions(query, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0]', fields: '$[1].fields' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _queryAvailableTicketDefinitionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _queryAvailableTicketDefinitionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#ticketDefinitions']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([query, options]);
        const reqOpts = ambassadorWixEventsV3TicketDefinition.queryAvailableTicketDefinitions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'query',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Counts ticket definitions by the `saleStatus` and `hidden` fields. <br> <br>
 * To learn about working with _query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * @public
 * @param options - Optional fields.
 * @adminMethod
 */
export function countTicketDefinitions(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0].filter', facet: '$[0].facet' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countTicketDefinitionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countTicketDefinitionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV3TicketDefinition.countTicketDefinitions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Counts ticket definitions that aren't in the `hidden` state. This endpoint counts tickets by the `saleStatus` field. <br> <br>
 * To learn about working with _query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * @public
 * @param options - Optional fields.
 */
export function countAvailableTicketDefinitions(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0].filter' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countAvailableTicketDefinitionsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countAvailableTicketDefinitionsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixEventsV3TicketDefinition.countAvailableTicketDefinitions(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes multiple ticket definitions.
 *
 * All ticket definitions that meet the specified `filter` criteria are deleted.
 * @param filter - Filter object in the following format: <br/> `"filter" : { "fieldName1": "value1" }`. <br/> <br/> **Example:** <br/> `"filter" : { "eventId": "3d3d5c04-ece0-45a8-85f0-11a58edaa192" }`
 * @public
 * @requiredField filter
 * @adminMethod
 */
export function bulkDeleteTicketDefinitionsByFilter(filter) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkDeleteTicketDefinitionsByFilterRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkDeleteTicketDefinitionsByFilterResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([filter]);
        const reqOpts = ambassadorWixEventsV3TicketDefinition.bulkDeleteTicketDefinitionsByFilter(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'filter',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * > **Note:** This function replaces the deprecated `changeCurrency()` function. The deprecated function will continue to work until November 8, 2024, but it will not receive updates. To keep any existing code compatible with future changes, see the [migration instructions](https://www.wix.com/velo/reference/wix-events-v2/ticketdefinitions/changecurrency).
 *
 * Changes ticket price currency per event.
 * @param eventId - Event ID.
 * @public
 * @requiredField eventId
 * @requiredField options
 * @requiredField options.currency
 * @param options - Optional fields.
 * @adminMethod
 */
export function changeCurrency(eventId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { eventId: '$[0]', currency: '$[1].currency' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _changeCurrencyRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _changeCurrencyResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([eventId, options]);
        const reqOpts = ambassadorWixEventsV3TicketDefinition.changeCurrency(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'eventId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=events-v3-ticket-definition.universal.js.map